export const resources = {
  en_US: {
    translation: {
      "available": "AVAILABLE",
      "unavailable": "UNAVAILABLE",
      "getStartButton": "Get Started",
      "getStartedAvailabilityTitle": "EQUIPMENT AVAILABILITY",
      "getStartedAvailabilityMessage": "Frustrated your favorite piece of cardio equipment is in use when you want to use it?  Don't worry we can now show you if your favorite equipment is available.",
      "getStartedOnDemandTitle": "LOOK FOR MOTIVATIONAL ON-DEMAND CLASSES",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand are high-quality, motivational classes with popular music. The classes offer a wide variety of programming styles for beginner, intermediate, and advanced exerciser.",
      "getStartedCardioConsolesTitle": "LIFE FITNESS & CYBEX CARDIO CONSOLES",
      "getStartedCardioConsolesMessage": "This website supports only Life Fitness Elevation Series cardio with Discover SE3, SE3HD, ST and Cybex 70T consoles.",
      "getStartedBottomMessage": "Only for Life Fitness & Cybex connected cardio equipment.",
      "onboardingSkipButton": "Skip",
      "onboardingNextButton": "Next",
      "onboardingDoneButton": "Done",
      "onboardingSupportMessage": "Learn which equipment consoles are supported in this widget.",
      "supportedTitle": "SUPPORTED CONSOLES",
      "supportedMessage": "This widget supports only Life Fitness Elevation Series cardio with Life Fitness <strong>Discover SE3, SE3HD, ST, consoles and Cybex 70T</strong> consoles.",
      "onboardingAvailabilityMessage": "Checkout which equipment is available or when one might become availabile",
      "graphTitle": "POPULAR TIMES",
      "graphMoreInfoMessage": "Based on the availability of Life Fitness or Cybex connected equipment",
      "graphToday": "Today",
      "graphNoDataMessage": "We are populating the graph with data. Please check back later.",
      "availabilityOnDemandMessage": "Your gym enabled Life Fitness™ On Demand classes. They are motivational instructor-guided cardio classes on different equipment types, thoughtfully designed to reach exercisers of all fitness levels, ranging between 10 and 40 minutes.",
      "treadmills": "Treadmills",
      "crossTrainers": "Cross Trainers",
      "recumbentBikes": "Recumbent Bikes",
      "uprightBikes": "Upright Bikes",
      "powermills": "Powermills",
      "gscTrainers": "GSC Trainers",
      "arcTrainers": "Arc Trainers",
      "unavailableEquipmentMessage": "The time below indicates workout elapsed time.",
      "january": "January",
      "feburary": "Feburary",
      "march": "March",
      "april": "April",
      "may": "May",
      "june": "June",
      "july": "July",
      "august": "August",
      "september": "September",
      "october": "October",
      "november": "November",
      "december": "December",
      "hourStatus": "Over 1 Hour",
      "offline": "offline",
      "console": "consoles",
      "features": "features",
      "status": "status",
      "notConnected": "Not Connected",
      "feedbackSend": "Send Us Your Feedback",
      "feedbackMessage": "Your feedback is important to us. This way we can keep improving this website. Please leave your feedback below:",
      "feedback": "Feedback",
      "email": "Email Address (Optional)",
      "cancelButton": "cancel",
      "sendButton": "send",
      "nextButton": "next",
      "doneButton": "done",
      "noEquipment": "No equipment is available at the moment. Please check back later.",
      "learnSupported": "Learn, which equipment consoles are supported by this website.",
      "learnAvialable": "Learn, which equiment is available or when it will become available",
      "statusTime": "The time indicates workout elasped time.",
      "statusNotConnected": "Halo Fitness is unable to communicate with this equipment."
    }
  },
  ar: {
    translation: {
      "available": "متوفر",
      "unavailable": "غير متوفر",
      "getStartButton": "البدء",
      "getStartedAvailabilityTitle": "توافر الأجهزة",
      "getStartedAvailabilityMessage": "هل تشعر بالإحباط عندما تجد أن جهاز تقوية القلب المفضل لك مستخدم عندما تريد استخدامه؟  لا تقلق، يمكننا الآن أن نعرض لك إذا كان جهازك المفضل متوفرًا.",
      "getStartedOnDemandTitle": "ابحث عن فصول تحفيزية عند الطلب",
      "getStartedOnDemandMessage": "تعتبر Life Fitness™ On Demand فصولاً تحفيزية وعالية الجودة. توفر الفصول مجموعة متنوعة من أنماط البرمجة للمتمرن المبتدئ والمتوسط والمتقدم.",
      "getStartedCardioConsolesTitle": "لوحات تحكم أجهزة تقوية القلب <strong>LIFE FITNESS و CYBEX",
      "getStartedCardioConsolesMessage": "يدعم هذا الموقع الإلكتروني فقط أجهزة تقوية القلب Life Fitness Elevation Series ذات لوحات التحكم Discover  وSE3 وSE3HD و وST  وCybex 70T",
      "getStartedBottomMessage": "فقط لأجهزة تقوية القلب Life Fitness و Cybex.",
      "onboardingSkipButton": "تخطي",
      "onboardingNextButton": "التالي",
      "onboardingDoneButton": "تم",
      "onboardingSupportMessage": "اعرف أي لوحات تحكم الأجهزة مدعومًا في عنصر واجهة المستخدم هذا.",
      "supportedTitle": "لوحات التحكم المدعومة",
      "supportedMessage": "يدعم عنصر واجهة المستخدم فقط أجهزة تقوية القلب Life Fitness Elevation Series ذات لوحات التحكم Life Fitness <strong>Discover SE3 وSE3HD وST و ولوحات التحكم Cybex 70T</strong>.",
      "onboardingAvailabilityMessage": "تحقق من أي الأجهزة متوفر أو عندما قد يصبح جهاز متوفرًا",
      "graphTitle": "الأوقات الأكثر شيوعًا",
      "graphMoreInfoMessage": "بناءً على توافر جهاز Life Fitness أو Cybex المتصل",
      "graphToday": "اليوم",
      "graphNoDataMessage": "نملأ الرسم البياني بالبيانات. يُرجى التحقق مرة أخرى لاحقًا.",
      "availabilityOnDemandMessage": "صالة الألعاب الرياضية الخاصة بك مكنت فصول Life Fitness™ On Demand. إنها فصول أجهزة تقوية القلب التحفيزية ذات توجيه من المعلمين التي تُقدم على أنواع مختلفة من الأجهزة، وهي مصممة بطريقة مثالية للوصول إلى المتمرنين من جميع مستويات اللياقة، والتي تتراوح من 10 دقائق حتى 40 دقيقة.",
      "treadmills": "أجهزة الجري",
      "crossTrainers": "أجهزة التمارين متعددة الأغراض",
      "recumbentBikes": "دراجات مزودة بمسند للظهر",
      "uprightBikes": "الدرَّاجات غير المزودة بمسند للظهر",
      "powermills": "أجهزة Powermill",
      "gscTrainers": "أجهزة التدريب GSC Trainers",
      "arcTrainers": "أجهزة Arc Trainer",
      "unavailableEquipmentMessage": "يُشير الوقت أدناه إلى الزمن المنقضي من التمرين.",
      "january": "يناير",
      "feburary": "فبراير",
      "march": "مارس",
      "april": "إبريل",
      "may": "مايو",
      "june": "يونيو",
      "july": "يوليو",
      "august": "أغسطس",
      "september": "سبتمبر",
      "october": "أكتوبر",
      "november": "نوفمبر",
      "december": "ديسمبر"
    }
  },
  ca: {
    translation: {
      "available": "DISPONIBLE",
      "unavailable": "NO DISPONIBLE",
      "getStartButton": "Ja podeu començar",
      "getStartedAvailabilityTitle": "DISPONIBILITAT DE L'EQUIP",
      "getStartedAvailabilityMessage": "Decebut perquè el vostre equip de càrdio preferit està ocupat i no el podeu utilitzar?  No us preocupeu. Ara us podem mostrar si el vostre equip preferit està disponible.",
      "getStartedOnDemandTitle": "BUSCAR CLASSES MOTIVADORES A PETICIÓ",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand són classes motivadores d'alta qualitat amb música d'actualitat. Les classes ofereixen una gran varietat d'estils de programació per a usuaris principiants, intermedis i avançats.",
      "getStartedCardioConsolesTitle": "CONSOLES DE CÀRDIO LIFE FITNESS I CYBEX",
      "getStartedCardioConsolesMessage": "Aquest lloc web només és compatible amb el càrdio de Life Fitness Elevation Series amb les consoles Discover SE3, SE3HD, ST i Cybex 70T.",
      "getStartedBottomMessage": "Només per a equips de càrdio connectats amb Life Fitness i Cybex.",
      "onboardingSkipButton": "Ometre",
      "onboardingNextButton": "Següent",
      "onboardingDoneButton": "Fet",
      "onboardingSupportMessage": "Coneixeu quines consoles d'equip són compatibles amb aquest giny.",
      "supportedTitle": "CONSOLES COMPATIBLES",
      "supportedMessage": "Aquest giny només és compatible amb el càrdio de Life Fitness Elevation Series amb les consoles Life Fitness <strong>Discover SE3, SE3HD, ST, i Cybex 70T</strong>.",
      "onboardingAvailabilityMessage": "Consulteu els equips que estan disponibles o quan n'hi haurà algun de disponible",
      "graphTitle": "HORES DE MÉS ASSISTÈNCIA",
      "graphMoreInfoMessage": "Segons la disponibilitat de l'equip connectat de Life Fitness o Cybex",
      "graphToday": "Avui",
      "graphNoDataMessage": "Estem generant les dades del gràfic. Torneu-ho a consultar més tard.",
      "availabilityOnDemandMessage": "Classes de Life Fitness™ On Demand habilitades per al gimnàs. Són classes motivadores de càrdio guiades per instructor a diferents tipus d'equip, dissenyades amb cura per adaptar-se a tots els nivells d'usuari, amb durades que oscil·len entre 10 i 40 minuts.",
      "treadmills": "Cintes de córrer",
      "crossTrainers": "Màquines el·líptiques d'entrenament combinat",
      "recumbentBikes": "Bicicletes reclinades",
      "uprightBikes": "Bicicletes verticals",
      "powermills": "Powermills",
      "gscTrainers": "GSC Trainers",
      "arcTrainers": "Arc Trainers",
      "unavailableEquipmentMessage": "El temps que es mostra a sota indica el temps d'entrenament transcorregut.",
      "january": "Gener",
      "feburary": "Febrer",
      "march": "Març",
      "april": "Abril",
      "may": "Maig",
      "june": "Juny",
      "july": "Juliol",
      "august": "Agost",
      "september": "Setembre",
      "october": "Octubre",
      "november": "Novembre",
      "december": "Desembre"
    }
  },
  cy: {
    translation: {
      "available": "AR GAEL",
      "unavailable": "DDIM AR GAEL",
      "getStartButton": "Dechreuwch",
      "getStartedAvailabilityTitle": "ARGAELEDD OFFER",
      "getStartedAvailabilityMessage": "Teimlo'n rhwystredig bod eich hoff declyn ymarfer cardio yn cael ei ddefnyddio pan fyddwch chi ei eisiau?  Peidiwch â phoeni, gallwn nawr ddangos i chi os yw'ch hoff offer ar gael.",
      "getStartedOnDemandTitle": "CHWILIWCH AM DDOSBARTHIADAU I'CH ANNOG AR ALW",
      "getStartedOnDemandMessage": "Mae Life Fitness™ On Demand yn ddosbarthiadau o ansawdd uchel, i'ch annog gyda cherddoriaeth boblogaidd. Mae'r dosbarthiadau yn cynnig amrywiaeth eang o arddulliau rhaglennu ar gyfer ymarferwyr sy'n dechrau arni, canolradd ac uwch.",
      "getStartedCardioConsolesTitle": "CONSOLAU CARDIO LIFE FITNESS A CYBEX",
      "getStartedCardioConsolesMessage": "Mae'r wefan hon yn cefnogi cardio Life Fitness Elevation Series gyda chonsolau Discover SE3, SE3HD, ST a Cybex 70T yn unig.",
      "getStartedBottomMessage": "Dim ond ar gyfer offer cardio Life Fitness a Cybex cysylltiedig.",
      "onboardingSkipButton": "Hepgor",
      "onboardingNextButton": "Nesaf",
      "onboardingDoneButton": "Wedi gorffen",
      "onboardingSupportMessage": "Dysgwch pa gonsolau fer a gefnogir yn y teclyn hwn.",
      "supportedTitle": "CONSOLAU A GEFNOGIR",
      "supportedMessage": "Mae'r teclyn hwn yn cefnogi cardio Life Fitness Elevation Series gyda chonsolau Life Fitness <strong>Discover SE3, SE3HD, ST a Cybex 70T</strong> yn unig.",
      "onboardingAvailabilityMessage": "Cymrwch olwg ar pa offer sydd ar gael neu pryd y gallai un fod ar gael",
      "graphTitle": "AMSERAU POBLOGAIDD",
      "graphMoreInfoMessage": "Yn seiliedig ar argaeledd offer cysylltiedig Life Fitness neu Cybex",
      "graphToday": "Heddiw",
      "graphNoDataMessage": "Rydyn ni'n poblogi'r graff gyda data. Gwiriwch eto'n hwyrach.",
      "availabilityOnDemandMessage": "Mae eich campfa wedi galluogi dosbarthiadau Life Fitness™ On Demand. Maent yn ddosbarthiadau i'ch annog dan arweiniad hyfforddwr ar wahanol fathau o offer, wedi eu cynllunio'n feddylgar i gyrraedd ymarferwyr o bob lefel ffitrwydd, yn amrywio rhwng 10 a 40 munud.",
      "treadmills": "Melinau traed",
      "crossTrainers": "Peiriannau Trawsymarfer",
      "recumbentBikes": "Beiciau Eistedd am yn Ôl",
      "uprightBikes": "Beiciau Eistedd i Fyny",
      "powermills": "Melinau Pŵer",
      "gscTrainers": "Peiriannau Ymarfer GSC",
      "arcTrainers": "Peiriannau Ymarfer Arc",
      "unavailableEquipmentMessage": "Mae'r amser isod yn dynodi'r amser ymarfer sydd wedi pasio.",
      "january": "Ionawr",
      "feburary": "Chwefror",
      "march": "Mawrth",
      "april": "Ebrill",
      "may": "Mai",
      "june": "Mehefin",
      "july": "Gorffennaf",
      "august": "Awst",
      "september": "Medi",
      "october": "Hydref",
      "november": "Tachwedd",
      "december": "Rhagfyr"
    }
  },
  da: {
    translation: {
      "available": "TILGÆNGELIG",
      "unavailable": "UTILGÆNGELIG",
      "getStartButton": "Kom i gang",
      "getStartedAvailabilityTitle": "TILGÆNGELIGHED AF UDSTYR",
      "getStartedAvailabilityMessage": "Bliver du frustreret, når dit foretrukne kardioudstyr er i brug, når du gerne vil bruge det?  Bare rolig – nu kan vi vise dig, om dit foretrukne udstyr er tilgængeligt.",
      "getStartedOnDemandTitle": "FIND MOTIVERENDE HOLD EFTER BEHOV",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand er motiverende holdtræning i høj kvalitet med populærmusik. Holdene tilbyder en bred vifte af træningsprogrammer til begyndere, øvede og avancerede motionister.",
      "getStartedCardioConsolesTitle": "LIFE FITNESS & CYBEX KARDIOKONSOLLER",
      "getStartedCardioConsolesMessage": "Denne hjemmeside understøtter kun Life Fitness Elevation Series-kardio på konsollerne Discover SE3, SE3HD, ST  og Cybex 70T.",
      "getStartedBottomMessage": "Kun for tilsluttet Life Fitness- og Cybex-kardioudstyr.",
      "onboardingSkipButton": "Spring over",
      "onboardingNextButton": "Næste",
      "onboardingDoneButton": "Afslut",
      "onboardingSupportMessage": "Lær mere om, hvilke udstyrskonsoller denne widget understøtter.",
      "supportedTitle": "UNDERSTØTTEDE KONSOLLER",
      "supportedMessage": "Denne widget understøtter kun Life Fitness Elevation Series-kardio på konsollerne Life Fitness <strong>Discover SE3, SE3HD, ST, og Cybex 70T</strong>.",
      "onboardingAvailabilityMessage": "Se, hvilket udstyr der er tilgængeligt, og hvornår udstyr sandsynligvis bliver tilgængeligt",
      "graphTitle": "POPULÆRE TIDSPUNKTER",
      "graphMoreInfoMessage": "Baseret på tilgængeligheden af det forbundne Life Fitness- eller Cybex-udstyr",
      "graphToday": "I dag",
      "graphNoDataMessage": "Vi udfylder grafen med data. Kig forbi igen senere.",
      "availabilityOnDemandMessage": "Dine Life Fitness™ On Demand-træningscenterhold. Dette er motiverende, instruktørstyrede kardiohold á 10 til 40 minutters varighed, hvor der bruges forskelligt slags udstyr. Holdene er designet til at favne motionister på alle fitnessniveauer.",
      "treadmills": "Løbebånd",
      "crossTrainers": "Crosstrainere",
      "recumbentBikes": "Siddecykler",
      "uprightBikes": "Motionscykler",
      "powermills": "Powermills",
      "gscTrainers": "GSC-trænere",
      "arcTrainers": "Arc-træningsmaskiner",
      "unavailableEquipmentMessage": "Tiden nedenfor er den forløbne træningstid.",
      "january": "Januar",
      "feburary": "Februar",
      "march": "Marts",
      "april": "April",
      "may": "Maj",
      "june": "Juni",
      "july": "Juli",
      "august": "August",
      "september": "September",
      "october": "Oktober",
      "november": "November",
      "december": "December"
    }
  },
  de: {
    translation: {
      "available": "VERFÜGBAR",
      "unavailable": "NICHT VERFÜGBAR",
      "getStartButton": "Erste Schritte",
      "getStartedAvailabilityTitle": "GERÄTEVERFÜGBARKEIT",
      "getStartedAvailabilityMessage": "Ist Ihr bevorzugtes Cardiogerät immer schon belegt, wenn Sie es verwenden möchten?  Keine Sorge, wir können Ihnen jetzt zeigen, wo das entsprechende Gerät verfügbar ist.",
      "getStartedOnDemandTitle": "MOTIVIERENDE ON-DEMAND-KURSE SUCHEN",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand sind qualitativ hochwertige motivierende Kurse mit Popmusik. Die Kurse bieten zahlreiche Möglichkeiten zur Programmgestaltung für Anfänger, fortgeschrittene und erfahrene Trainierende.",
      "getStartedCardioConsolesTitle": "LIFE FITNESS UND CYBEX CARDIO-KONSOLEN",
      "getStartedCardioConsolesMessage": "Diese Website unterstützt nur Cardiogeräte der Life Fitness Elevation Series mit den Konsolen Discover SE3, SE3HD, ST und Cybex 70T.",
      "getStartedBottomMessage": "Nur für vernetzte Life Fitness und Cybex Cardiogeräte.",
      "onboardingSkipButton": "Überspringen",
      "onboardingNextButton": "Weiter",
      "onboardingDoneButton": "Fertig",
      "onboardingSupportMessage": "Informieren Sie sich, welche Gerätekonsolen in diesem Widget unterstützt werden.",
      "supportedTitle": "UNTERSTÜTZTE KONSOLEN",
      "supportedMessage": "Dieses Widget unterstützt nur Cardiogeräte der Life Fitness Elevation Series mit den Konsolen Life Fitness <strong>Discover SE3, SE3HD, ST, und Cybex 70T</strong>.",
      "onboardingAvailabilityMessage": "Finden Sie heraus, welche Geräte verfügbar sind oder wann Geräte möglicherweise verfügbar werden",
      "graphTitle": "BELIEBTE ZEITEN",
      "graphMoreInfoMessage": "Basierend auf der Verfügbarkeit der vernetzten Life Fitness oder Cybex Geräte",
      "graphToday": "Heute",
      "graphNoDataMessage": "Wir füllen das Diagramm mit Daten. Schauen Sie später noch einmal vorbei.",
      "availabilityOnDemandMessage": "Ihr Studio hat Life Fitness™ On Demand-Kurse aktiviert. Dabei handelt es sich um motivierende, durch Trainer angeleitete Cardio-Kurse auf verschiedenen Gerätetypen, die alle Schwierigkeitsgrade abdecken und eine Dauer von 10 bis 40 Minuten haben.",
      "treadmills": "Laufbänder",
      "crossTrainers": "Crosstrainer",
      "recumbentBikes": "Liegeergometer",
      "uprightBikes": "Sitzergometer",
      "powermills": "PowerMills",
      "gscTrainers": "GSC Trainer",
      "arcTrainers": "Arc Trainer",
      "unavailableEquipmentMessage": "Die Zeit unten zeigt die abgelaufene Workout-Zeit an.",
      "january": "Januar",
      "feburary": "Februar",
      "march": "März",
      "april": "April",
      "may": "Mai",
      "june": "Juni",
      "july": "Juli",
      "august": "August",
      "september": "September",
      "october": "Oktober",
      "november": "November",
      "december": "Dezember"
    }
  },
  en: {
    translation: {
      "available": "AVAILABLE",
      "unavailable": "UNAVAILABLE",
      "getStartButton": "Get Started",
      "getStartedAvailabilityTitle": "EQUIPMENT AVAILABILITY",
      "getStartedAvailabilityMessage": "Frustrated your favourite piece of cardio equipment is in use when you want to use it?  Don't worry! We can now show you whether your favourite equipment is available.",
      "getStartedOnDemandTitle": "LOOK FOR MOTIVATIONAL ON-DEMAND CLASSES",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand are high-quality, motivational classes with popular music. The classes offer a wide variety of programming styles for beginner, intermediate and advanced exercisers.",
      "getStartedCardioConsolesTitle": "LIFE FITNESS & CYBEX CARDIO CONSOLES",
      "getStartedCardioConsolesMessage": "This website supports only Life Fitness Elevation Series cardio with Discover SE3, SE3HD, ST and Cybex 70T consoles.",
      "getStartedBottomMessage": "Only for Life Fitness & Cybex connected cardio equipment.",
      "onboardingSkipButton": "Skip",
      "onboardingNextButton": "Next",
      "onboardingDoneButton": "Done",
      "onboardingSupportMessage": "Learn which equipment consoles are supported in this widget.",
      "supportedTitle": "SUPPORTED CONSOLES",
      "supportedMessage": "This widget supports only Life Fitness Elevation Series cardio with Life Fitness <strong>Discover SE3, SE3HD, ST and Cybex 70T</strong> consoles.",
      "onboardingAvailabilityMessage": "See which equipment is available or when it might become available",
      "graphTitle": "POPULAR TIMES",
      "graphMoreInfoMessage": "Based on the availability of Life Fitness or Cybex connected equipment",
      "graphToday": "Today",
      "graphNoDataMessage": "We are populating the graph with data. Please check again later.",
      "availabilityOnDemandMessage": "Your gym enabled Life Fitness™ On Demand classes. They are motivational instructor-guided cardio classes on different equipment types, thoughtfully designed to reach exercisers of all fitness levels, lasting between 10 and 40 minutes.",
      "treadmills": "Treadmills",
      "crossTrainers": "Cross Trainers",
      "recumbentBikes": "Recumbent Bikes",
      "uprightBikes": "Upright Bikes",
      "powermills": "PowerMills",
      "gscTrainers": "GSC Trainers",
      "arcTrainers": "Arc Trainers",
      "unavailableEquipmentMessage": "The time below indicates workout time elapsed.",
      "january": "January",
      "feburary": "February",
      "march": "March",
      "april": "April",
      "may": "May",
      "june": "June",
      "july": "July",
      "august": "August",
      "september": "September",
      "october": "October",
      "november": "November",
      "december": "December"
    }
  },
  es: {
    translation: {
      "available": "DISPONIBLE",
      "unavailable": "NO DISPONIBLE",
      "getStartButton": "Empezar",
      "getStartedAvailabilityTitle": "DISPONIBILIDAD DEL EQUIPO",
      "getStartedAvailabilityMessage": "¿Te frustra que tu equipo de cardio favorito esté ocupado cuando quieres usarlo?  No te preocupes. Ahora podemos mostrarte si tu equipo favorito está disponible.",
      "getStartedOnDemandTitle": "BUSCA CLASES BAJO DEMANDA QUE TE MOTIVEN",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand son clases motivadoras de alta calidad con música conocida. Las clases ofrecen una amplia variedad de estilos de planificación tanto para principiantes como para los usuarios de nivel intermedio y avanzado.",
      "getStartedCardioConsolesTitle": "CONSOLAS DE CARDIO LIFE FITNESS Y CYBEX",
      "getStartedCardioConsolesMessage": "Esta página web solo admite equipos de cardio Life Fitness Elevation Series con consolas Discover SE3, SE3 HD, ST y Cybex 70T.",
      "getStartedBottomMessage": "Solo para equipos de cardio conectados Life Fitness y Cybex.",
      "onboardingSkipButton": "Omitir",
      "onboardingNextButton": "Siguiente",
      "onboardingDoneButton": "Hecho",
      "onboardingSupportMessage": "Descubre las consolas de equipos que son compatibles con este widget.",
      "supportedTitle": "CONSOLAS COMPATIBLES",
      "supportedMessage": "Este widget solo admite equipos de cardio Life Fitness Elevation Series con consolas Life Fitness <strong>Discover SE3, SE3 HD, ST y consolas Cybex 70T</strong>.",
      "onboardingAvailabilityMessage": "Consulta qué equipo está disponible o cuando podría estarlo.",
      "graphTitle": "HORARIOS POPULARES",
      "graphMoreInfoMessage": "Según la disponibilidad de los equipos conectados Life Fitness o Cybex",
      "graphToday": "Hoy",
      "graphNoDataMessage": "Estamos rellenado el gráfico con datos. Vuelve más tarde.",
      "availabilityOnDemandMessage": "Tu gimnasio habilitó las clases de Life Fitness™ On Demand. Se trata de clases de cardio motivadoras y guiadas por un instructor en distintos tipos de equipos, muy bien diseñadas para llegar a los usuarios de todos los estados físicos, con una duración de entre 10 y 40 minutos.",
      "treadmills": "Cintas de correr",
      "crossTrainers": "Elípticas",
      "recumbentBikes": "Bicicletas reclinables",
      "uprightBikes": "Bicicletas verticales",
      "powermills": "Máquinas PowerMill",
      "gscTrainers": "Elípticas GSC",
      "arcTrainers": "Arc Trainers",
      "unavailableEquipmentMessage": "El tiempo de abajo indica el tiempo transcurrido desde el entrenamiento.",
      "january": "Enero",
      "feburary": "Febrero",
      "march": "Marzo",
      "april": "Abril",
      "may": "Mayo",
      "june": "Junio",
      "july": "Julio",
      "august": "Agosto",
      "september": "Septiembre",
      "october": "Octubre",
      "november": "Noviembre",
      "december": "Diciembre",
      "hourStatus": "Más de 1 hora",
      "offline": "offline",
      "console": "consolas",
      "features": "funcionalidades",
      "status": "estado",
      "notConnected": "No Conectado",
      "feedbackSend": "Envíanos tus comentarios",
      "feedbackMessage": "Tu opinión es muy importante para nosotros. De esta forma, podemos seguir mejorando este sitio web. Deja tus comentarios a continuación:",
      "feedback": "Comentarios",
      "email": "Dirección de correo electrónico (opcional)",
      "cancelButton": "cancelar",
      "sendButton": "enviar",
      "nextButton": "siguiente",
      "doneButton": "hecho",
      "noEquipment": "En este momento no hay equipos disponibles. Por favor, compruébalo más tarde.",
      "learnSupported": "Conoce qué consolas de los equipo de fitness son compatibles con esta herramienta.",
      "learnAvialable": "Descubre qué equipos están disponibles o cuándo estarán disponibles",
      "statusTime": "El tiempo indica el tiempo transcurrido del entrenamiento.",
      "statusNotConnected": "Halo Fitness no puede comunicarse con este equipo"
    }
  },
  eu: {
    translation: {
      "available": "ERABILGARRI",
      "unavailable": "EZ-ERABILGARRI",
      "getStartButton": "Has zaitez",
      "getStartedAvailabilityTitle": "EKIPAMENDUAREN ERABILGARRITASUNA",
      "getStartedAvailabilityMessage": "Atsekabetuta zaude zure kardio-ekipamendu gogokoena okupatuta dagoelako zuk erabili nahi duzunean?  Ez kezkatu, orain zure gogoko ekipamendua libre dagoen erakuts diezazukegu.",
      "getStartedOnDemandTitle": "BILATU ESKATU AHALAKO MOTIBAZIOA PIZTEKO KLASEAK",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand kalitate handiko motibazioa pizteko klaseak dira, musika oso ezagunarekin lagunduta. Klaseek estilo desberdineko sorta zabala eskatzen dute hasiberrientzat, tartekoentzat eta aurreratuentzat.",
      "getStartedCardioConsolesTitle": "LIFE FITNESS & CYBEX KARDIOKONTSOLAK",
      "getStartedCardioConsolesMessage": "Webgune honek Life Fitness Elevation Series kardioa Discover SE3, SE3HD, ST eta Cybex 70T kontsolekin soilik onartzen du.",
      "getStartedBottomMessage": "Life Fitness eta Cybex konektatutako ekipamenduentzat soilik da.",
      "onboardingSkipButton": "Saltatu",
      "onboardingNextButton": "Hurrengoa",
      "onboardingDoneButton": "Eginda",
      "onboardingSupportMessage": "Ezagutu zein ekipamendu-kontsola onartzen diren widget honetan.",
      "supportedTitle": "ONARTUTAKO KONTSOLAK",
      "supportedMessage": "Widget honek Life Fitness Elevation Series kardioa Life Fitness <strong>Discover SE3, SE3HD, ST kontsolekin eta Cybex 70T</strong> kontsolekin soilik onartzen ditu.",
      "onboardingAvailabilityMessage": "Ezagutu zein ekipamendu dagoen erabilgarri edo noiz izango den bat erabilgarri",
      "graphTitle": "ORDU OKUPATUENAK",
      "graphMoreInfoMessage": "Life Fitness edo Cybex-era konektatutako ekipamenduen erabilgarritasunean oinarrituta",
      "graphToday": "Gaur",
      "graphNoDataMessage": "Grafiko bat osatzen ari gara datuekin. Itzuli berriro geroago.",
      "availabilityOnDemandMessage": "Zure gimnasioak Life Fitness™ On Demand klaseak gaitu ditu. Monitore batek gidatutako motibazioa pizteko kardio-klaseak dira ekipamendu mota desberdinetan. Maila guztietako ariketa-egileentzat egin dira, eta 10 eta 40 minutu artean irauten dute.",
      "treadmills": "Korrika egiteko zintak",
      "crossTrainers": "Cross entrenatzaileak",
      "recumbentBikes": "Bizikleta etzanak",
      "uprightBikes": "Bizikleta bertikalak",
      "powermills": "Powermill-ak",
      "gscTrainers": "GSC Trainerrak",
      "arcTrainers": "Arc entrenatzaileak",
      "unavailableEquipmentMessage": "Entrenamenduan pasatutako denbora adierazten du beheko denborak.",
      "january": "Urtarrila",
      "feburary": "Otsaila",
      "march": "Martxoa",
      "april": "Apirila",
      "may": "Maiatza",
      "june": "Ekaina",
      "july": "Uztaila",
      "august": "Abuztua",
      "september": "Iraila",
      "october": "Urria",
      "november": "Azaroa",
      "december": "Abendua"
    }
  },
  fi: {
    translation: {
      "available": "VAPAANA",
      "unavailable": "VARATTU",
      "getStartButton": "Aloitetaan",
      "getStartedAvailabilityTitle": "LAITTEEN SAATAVUUS",
      "getStartedAvailabilityMessage": "Harmittaako sinua, jos lempilaitteesi on varattuna juuri kun haluaisit käyttää sitä?  Ei syytä huoleen – järjestelmämme osaa näyttää, milloin lempilaitteesi on vapaana.",
      "getStartedOnDemandTitle": "ETSI MOTIVOIVIA TILAUSTUNTEJA",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand -tunnit ovat laadukkaita ja motivoivia, uusimman musiikin tahdittamia liikuntatunteja. Tuntivalikoimaan kuuluu paljon erilaisia vaihtoehtoja niin aloittelijoille kuin keskitason ja edistyneille harjoittelijoillekin.",
      "getStartedCardioConsolesTitle": "LIFE FITNESS- & CYBEX-KESTÄVYYSKONSOLIT",
      "getStartedCardioConsolesMessage": "Tämä sivusto tukee vain Life Fitness Elevation Series -kestävyyslaitteita, joissa on Discover SE3-, SE3HD-, ST - tai Cybex 70T -konsoli.",
      "getStartedBottomMessage": "Vain yhdistetyille Life Fitness- ja Cybex-kestävyyslaitteille.",
      "onboardingSkipButton": "Ohita",
      "onboardingNextButton": "Seuraava",
      "onboardingDoneButton": "Valmis",
      "onboardingSupportMessage": "Katso, mitä laitekonsoleita tämä pienoissovellus tukee.",
      "supportedTitle": "TUETUT KONSOLIT",
      "supportedMessage": "Tämä pienoissovellus tukee vain Life Fitness Elevation Series -kestävyyslaitteita, joissa on Life Fitness <strong>Discover SE3-, SE3HD-, ST- tai tai Cybex 70T</strong> -konsoli.",
      "onboardingAvailabilityMessage": "Katso, mitkä laitteet ovat vapaina tai koska jokin tietty laite saattaa vapautua.",
      "graphTitle": "SUOSITUT AJAT",
      "graphMoreInfoMessage": "Perustuu yhdistettyjen Life Fitness- ja Cybex-laitteiden käyttötietoihin",
      "graphToday": "Tänään",
      "graphNoDataMessage": "Kaavion tietoja päivitetään. Yritä myöhemmin uudelleen.",
      "availabilityOnDemandMessage": "Kuntosalillasi on käytössä Life Fitness™ On Demand -tunnit. Ne ovat motivoivia, ohjaajan vetämiä kestävyysharjoittelutunteja, joissa hyödynnetään erilaisia laitteita. Tunnit on suunniteltu tarkasti kaikentasoisten harjoittelijoiden tarpeisiin, ja ne ovat kestoltaan 10–40 minuuttia.",
      "treadmills": "Juoksumatot",
      "crossTrainers": "Crosstrainerit",
      "recumbentBikes": "Recumbent-kuntopyörät",
      "uprightBikes": "Pystypyörät",
      "powermills": "PowerMill-porraskoneet",
      "gscTrainers": "GSC Trainerit",
      "arcTrainers": "Arc Trainerit",
      "unavailableEquipmentMessage": "Alla näkyvä aika näyttää harjoituksen keston.",
      "january": "Tammikuu",
      "feburary": "Helmikuu",
      "march": "Maaliskuu",
      "april": "Huhtikuu",
      "may": "Toukokuu",
      "june": "Kesäkuu",
      "july": "Heinäkuu",
      "august": "Elokuu",
      "september": "Syyskuu",
      "october": "Lokakuu",
      "november": "Marraskuu",
      "december": "Joulukuu"
    }
  },
  fr: {
    translation: {
      "available": "DISPONIBLE",
      "unavailable": "INDISPONIBLE",
      "getStartButton": "Démarrer",
      "getStartedAvailabilityTitle": "DISPONIBILITÉ DES ÉQUIPEMENTS",
      "getStartedAvailabilityMessage": "Vous regrettez que votre équipement cardio préféré soit occupé quand vous voulez l'utiliser ?  Réjouissez-vous ! Nous pouvons maintenant vous indiquer si votre équipement préféré est disponible.",
      "getStartedOnDemandTitle": "RECHERCHER DES COURS DE MOTIVATION À LA DEMANDE",
      "getStartedOnDemandMessage": "Les cours Life Fitness™ On Demand sont des cours de motivation de haute qualité sur les musiques les plus populaires. Ces cours proposent une large variété de programmes à tous les utilisateurs, qu'ils soient débutants, intermédiaires ou avancés.",
      "getStartedCardioConsolesTitle": "CONSOLES CARDIO <strong>LIFE FITNESS et CYBEX",
      "getStartedCardioConsolesMessage": "Ce site Web ne prend en charge que les équipements cardio Life Fitness Elevation Series équipés des consoles Discover SE3, SE3HD, ST et Cybex 70T.",
      "getStartedBottomMessage": "Uniquement compatible avec les équipements cardio connectés Life Fitness et Cybex.",
      "onboardingSkipButton": "Ignorer",
      "onboardingNextButton": "Suivant",
      "onboardingDoneButton": "Terminé",
      "onboardingSupportMessage": "Utilisez ce widget pour connaître les consoles d'équipement compatibles.",
      "supportedTitle": "CONSOLES COMPATIBLES",
      "supportedMessage": "Ce widget n'est compatible qu'avec les équipements cardio Life Fitness Elevation Series équipés des consoles Life Fitness <strong>Discover SE3, SE3HD, ST ou des consoles Cybex 70T</strong>.",
      "onboardingAvailabilityMessage": "Vérifiez les équipements disponibles, ou le moment où l'un d'entre eux pourrait devenir disponible",
      "graphTitle": "HORAIRES D'AFFLUENCE",
      "graphMoreInfoMessage": "En fonction de la disponibilité des équipements Life Fitness ou Cybex",
      "graphToday": "Aujourd'hui",
      "graphNoDataMessage": "Nous sommes en train de remplir le graphique avec des données. Veuillez réessayer plus tard.",
      "availabilityOnDemandMessage": "Votre salle de gym propose des cours Life Fitness™ On Demand Il s'agit de cours de cardio motivants d'une durée comprise entre 10 et 40 minutes, guidés par un coach sur différents types d'équipement. Ils sont soigneusement conçus pour intéresser les utilisateurs de tous les niveaux de forme physique.",
      "treadmills": "Tapis de course",
      "crossTrainers": "Vélos elliptiques",
      "recumbentBikes": "Vélos allongés",
      "uprightBikes": "Vélos droits",
      "powermills": "Powermills",
      "gscTrainers": "GSC Trainers",
      "arcTrainers": "Arc Trainers",
      "unavailableEquipmentMessage": "Le temps ci-dessous indique le temps d'entraînement écoulé.",
      "january": "Janvier",
      "feburary": "Février",
      "march": "Mars",
      "april": "Avril",
      "may": "Mai",
      "june": "Juin",
      "july": "Juillet",
      "august": "Août",
      "september": "Septembre",
      "october": "Octobre",
      "november": "Novembre",
      "december": "Décembre"
    }
  },
  he: {
    translation: {
      "available": "זמין",
      "unavailable": "לא זמין",
      "getStartButton": "התחלה",
      "getStartedAvailabilityTitle": "זמינות הציוד",
      "getStartedAvailabilityMessage": "מתבאס שציוד הכושר האירובי המועדף עליך תפוס כאשר אתה רוצה להשתמש בו?  אל דאגה, כעת אנו יכולים להראות לך אם הציוד המועדף עליך זמין.",
      "getStartedOnDemandTitle": "חיפוש שיעורים מעוררי השראה לפי דרישה",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand הם שיעורים מעוררי השראה, באיכות גבוהה, עם מוזיקה פופולרית. השיעורים מציעים מגוון רחב של סגנונות תוכנית למתאמן ברמת מתחילים, ברמת ביניים וברמה מתקדמת.",
      "getStartedCardioConsolesTitle": "מסופים אירוביים של LIFE FITNESS ו-CYBEX",
      "getStartedCardioConsolesMessage": "אתר אינטרנט זה תומך רק בציוד כושר אירובי של Life Fitness Elevation Series עם המסופים Discover SE3, SE3HD, ST ו- Cybex 70T.",
      "getStartedBottomMessage": "רק לציוד כושר מחובר של Life Fitness ו-Cybex.",
      "onboardingSkipButton": "דלג",
      "onboardingNextButton": "הבא",
      "onboardingDoneButton": "סיום",
      "onboardingSupportMessage": "גלה אילו מסופי ציוד נתמכים בווידג'ט זה.",
      "supportedTitle": "מסופים נתמכים",
      "supportedMessage": "וידג'ט זה תומך רק בציוד כושר אירובי של Life Fitness Elevation Series עם המסופים Life Fitness <strong>Discover SE3, SE3HD, ST, ו-Cybex 70T</strong>.",
      "onboardingAvailabilityMessage": "בדוק איזה ציוד זמין או מתי הציוד יכול להתפנות",
      "graphTitle": "שעות נפוצות",
      "graphMoreInfoMessage": "בהתבסס על זמינות הציוד המחובר של Life Fitness או Cybex",
      "graphToday": "היום",
      "graphNoDataMessage": "אנו ממלאים את הגרף בנתונים. בדוק שוב מאוחר יותר.",
      "availabilityOnDemandMessage": "המכון שלך הפעיל את שיעורי Life Fitness™ On Demand. אלה הם שיעורים אירוביים מעוררי השראה בהנחיית מדריך, עם סוגי ציוד שונים, שנוצרו בקפידה במטרה להתאים למתאמנים בכל רמות הכושר, ואורכם נע בין 10 ל-40 דקות.",
      "treadmills": "הליכונים",
      "crossTrainers": "מכשירים אליפטיים",
      "recumbentBikes": "אופניים עם משענות",
      "uprightBikes": "אופניים ללא משענות",
      "powermills": "מכשירי PowerMill",
      "gscTrainers": "מכשירי GSC",
      "arcTrainers": "מכשירי Arc Trainer",
      "unavailableEquipmentMessage": "הזמן שלהלן מציין את הזמן שחלף באימון.",
      "january": "ינואר",
      "feburary": "פברואר",
      "march": "מרץ",
      "april": "אפריל",
      "may": "מאי",
      "june": "יוני",
      "july": "יולי",
      "august": "אוגוסט",
      "september": "ספטמבר",
      "october": "אוקטובר",
      "november": "נובמבר",
      "december": "דצמבר"
    }
  },
  hu: {
    translation: {
      "available": "SZABAD",
      "unavailable": "FOGLALT",
      "getStartButton": "Első lépések",
      "getStartedAvailabilityTitle": "BERENDEZÉS ELÉRHETŐSÉGE",
      "getStartedAvailabilityMessage": "Önt is zavarja, ha kedvenc kardiogépe foglalt, amikor edzeni szeretne rajta?  Most már meg tudjuk mutatni, hogy kedvenc gépe szabad-e.",
      "getStartedOnDemandTitle": "MOTIVÁLÓ IGÉNY SZERINTI EDZÉSEK KERESÉSE",
      "getStartedOnDemandMessage": "A Life Fitness™ On Demand órák kiváló minőségű, motiváló edzések népszerű zenékkel. Az edzések sokféle különböző stílusú programot kínálnak kezdőknek, haladóknak és profiknak.",
      "getStartedCardioConsolesTitle": "LIFE FITNESS és CYBEX KARDIOKONZOLOK",
      "getStartedCardioConsolesMessage": "A weboldal csak a Life Fitness Elevation Series kardiogép-sorozat Discover SE3, SE3HD, ST és Cybex 70T konzollal felszerelt tagjait támogatja.",
      "getStartedBottomMessage": "Csak a Life Fitness és Cybex csatlakoztatott kardioberendezésekhez.",
      "onboardingSkipButton": "Kihagyás",
      "onboardingNextButton": "Tovább",
      "onboardingDoneButton": "Kész",
      "onboardingSupportMessage": "Tekintse meg, melyik berendezéskonzolokat támogatja ez a widget.",
      "supportedTitle": "TÁMOGATOTT KONZOLOK",
      "supportedMessage": "A widget csak a Life Fitness Elevation Series kardiogép-sorozat Life Fitness <strong>Discover SE3, SE3HD, ST, konzollal és Cybex 70T</strong> konzollal felszerelt tagjait támogatja.",
      "onboardingAvailabilityMessage": "Megnézheti, melyik berendezés szabad, illetve melyik válhat szabaddá",
      "graphTitle": "NÉPSZERŰ IDŐSZAKOK",
      "graphMoreInfoMessage": "A Life Fitness vagy Cybex csatlakoztatott berendezések elérhetősége alapján",
      "graphToday": "Ma",
      "graphNoDataMessage": "Jelenleg adatokkal töltjük fel a diagramot. Kérjük, nézzen vissza később.",
      "availabilityOnDemandMessage": "Az edzőterem engedélyezte a Life Fitness™ On Demand órákat. Ezek olyan motiváló, többféle berendezésen végezhető, instruktor által vezetett kardioedzések, amelyeket gondosan állítottak össze úgy, hogy minden erőnléti szinten használhatók legyenek. Az edzések 10–40 percesek.",
      "treadmills": "Futópadok",
      "crossTrainers": "Ellipszistrénerek",
      "recumbentBikes": "Háttámlás teremkerékpárok",
      "uprightBikes": "Ülő teremkerékpárok",
      "powermills": "Powermill trénerek",
      "gscTrainers": "GSC trénerek",
      "arcTrainers": "Arc trénerek",
      "unavailableEquipmentMessage": "Az alábbi érték az edzésből eltelt időt mutatja.",
      "january": "január",
      "feburary": "február",
      "march": "március",
      "april": "április",
      "may": "május",
      "june": "június",
      "july": "július",
      "august": "augusztus",
      "september": "szeptember",
      "october": "október",
      "november": "november",
      "december": "december"
    }
  },
  it: {
    translation: {
      "available": "DISPONIBILE",
      "unavailable": "NON DISPONIBILE",
      "getStartButton": "Inizia",
      "getStartedAvailabilityTitle": "DISPONIBILITÀ ATTREZZATURA",
      "getStartedAvailabilityMessage": "Infastidito dal fatto che qualcun altro stia usando la tua attrezzatura cardiovascolare preferita quando vorresti usarla tu?  Non preoccuparti. Ora siamo in grado di farti sapere se la tua attrezzatura preferita è disponibile.",
      "getStartedOnDemandTitle": "CERCA LEZIONI ON DEMAND CON PROGRAMMI STIMOLANTI",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand propone lezioni stimolanti e di alta qualità con musica pop. Le sessioni offrono un'ampia varietà di stili di programmazione per utenti di livello iniziale, intermedio e avanzato.",
      "getStartedCardioConsolesTitle": "CONSOLE CARDIO LIFE FITNESS E CYBEX",
      "getStartedCardioConsolesMessage": "Questo sito Web supporta solo attrezzature cardiovascolari Life Fitness Elevation Series con console Discover SE3, SE3HD, ST e Cybex 70T.",
      "getStartedBottomMessage": "Solo per attrezzature cardiovascolari connesse Life Fitness e Cybex.",
      "onboardingSkipButton": "Ignora",
      "onboardingNextButton": "Successivo",
      "onboardingDoneButton": "Fine",
      "onboardingSupportMessage": "Scopri quali console per le attrezzature sono supportate in questo widget.",
      "supportedTitle": "CONSOLE SUPPORTATE",
      "supportedMessage": "Questo widget supporta solo attrezzature cardiovascolari Life Fitness Elevation Series con console Life Fitness <strong>Discover SE3, SE3HD, ST, e console Cybex 70T</strong>.",
      "onboardingAvailabilityMessage": "Scopri quali sono le attrezzature disponibili o quando un'attrezzatura potrebbe essere libera",
      "graphTitle": "ORARI PIÙ FREQUENTATI",
      "graphMoreInfoMessage": "Dati basati sulla disponibilità delle attrezzature Life Fitness o Cybex collegate",
      "graphToday": "Oggi",
      "graphNoDataMessage": "Stiamo popolando il grafico con i dati disponibili. Ricontrolla più tardi.",
      "availabilityOnDemandMessage": "La tua palestra ha attivato le lezioni Life Fitness™ On Demand. Si tratta di stimolanti lezioni cardio guidate da un istruttore, della durata di 10-40 minuti, che utilizzano diversi tipi di attrezzature e sono attentamente preparate per soddisfare utenti di tutti i livelli di fitness.",
      "treadmills": "Tapis roulant",
      "crossTrainers": "Cross-trainer",
      "recumbentBikes": "Cyclette orizzontali",
      "uprightBikes": "Cyclette verticali",
      "powermills": "Powermill",
      "gscTrainers": "GSC Trainer",
      "arcTrainers": "Arc Trainer",
      "unavailableEquipmentMessage": "Viene indicato il tempo trascorso dall'inizio dell'allenamento.",
      "january": "Gennaio",
      "feburary": "Febbraio",
      "march": "Marzo",
      "april": "Aprile",
      "may": "Maggio",
      "june": "Giugno",
      "july": "Luglio",
      "august": "Agosto",
      "september": "Settembre",
      "october": "Ottobre",
      "november": "Novembre",
      "december": "Dicembre"
    }
  },
  ja: {
    translation: {
      "available": "利用可能",
      "unavailable": "利用不可",
      "getStartButton": "今すぐ始めましょう",
      "getStartedAvailabilityTitle": "マシンの利用状況",
      "getStartedAvailabilityMessage": "お気に入りのカーディオ・マシンを使おうとしたら、誰かに使われていてストレスを感じたこと、ありませんか? ご安心ください。マシンの利用状況を確認できるようになりました。",
      "getStartedOnDemandTitle": "意欲的に取り組めるオンデマンド クラスを探す",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand は、人気の音楽を使った意欲的に取り組める質の高いクラスで、初心者から中級者、上級者向けまで幅広いプログラムをご用意しています。",
      "getStartedCardioConsolesTitle": "LIFE FITNESS および CYBEX カーディオ・コンソール",
      "getStartedCardioConsolesMessage": "この Web サイトは、Discover SE3、SE3HD、ST 、Cybex 70T コンソールを備えた Life Fitness Elevation Series カーディオにのみ対応しています。",
      "getStartedBottomMessage": "Life Fitness および Cybex 接続済みカーディオ・マシンにのみ対応。",
      "onboardingSkipButton": "スキップ",
      "onboardingNextButton": "次へ",
      "onboardingDoneButton": "完了",
      "onboardingSupportMessage": "このウィジェットに対応するマシン コンソールを確認します。",
      "supportedTitle": "対応コンソール",
      "supportedMessage": "このウィジェットは、Life Fitness <strong>Discover SE3、SE3HD、ST、 コンソール、および Cybex 70T</strong> コンソールを備えた Life Fitness Elevation Series カーディオにのみ対応しています。",
      "onboardingAvailabilityMessage": "利用可能なマシン、またはマシンが利用可能なる時間帯を確認します",
      "graphTitle": "人気の時間帯",
      "graphMoreInfoMessage": "Life Fitness または Cybex 接続済みマシンの利用状況に基づく",
      "graphToday": "今日",
      "graphNoDataMessage": "グラフにデータを入力中です。後でご確認ください。",
      "availabilityOnDemandMessage": "ご自身のジム対応 Life Fitness™ On Demand クラス。さまざまなマシンに用意された意欲的に取り組めるカーディオ・クラス。あらゆるフィットネス レベルのユーザーに合わせて考え抜かれたクラスで、インストラクターが 10 ～ 40 分にわたって指導します。",
      "treadmills": "トレッドミル",
      "crossTrainers": "クロス・トレーナー",
      "recumbentBikes": "リカンベント・バイク",
      "uprightBikes": "アップライト・バイク",
      "powermills": "パワーミル",
      "gscTrainers": "GSC トレーナー",
      "arcTrainers": "アーク・トレーナー",
      "unavailableEquipmentMessage": "以下の時間はワークアウト経過時間です。",
      "january": "1月",
      "feburary": "2月",
      "march": "3月",
      "april": "4月",
      "may": "5月",
      "june": "6月",
      "july": "7月",
      "august": "8月",
      "september": "9月",
      "october": "10月",
      "november": "11月",
      "december": "12月"
    }
  },
  ko: {
    translation: {
      "available": "사용 가능",
      "unavailable": "사용 불가",
      "getStartButton": "시작",
      "getStartedAvailabilityTitle": "장비 이용 가능성",
      "getStartedAvailabilityMessage": "즐겨 찾는 유산소 운동 기구가 원하는 때에 이미 사용 중이라서 실망하셨나요?  걱정 마세요. 이제 즐겨 찾는 기구를 이용할 수 있는지 보여 드릴 수 있습니다.",
      "getStartedOnDemandTitle": "동기를 부여해 주는 주문형 클래스를 찾아 보세요",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand는 인기 음악과 함께하는 고품질의 동기부여 클래스입니다. 클래스에서는 초급, 중급, 고급 훈련자를 위한 매우 다양한 프로그래밍 스타일을 제공합니다.",
      "getStartedCardioConsolesTitle": "LIFE FITNESS 및 CYBEX 유산소 운동 콘솔",
      "getStartedCardioConsolesMessage": "이 웹사이트는 Discover SE3, SE3HD, ST , Cybex 70T 콘솔을 통한 Life Fitness Elevation Series 유산소 운동만을 지원합니다.",
      "getStartedBottomMessage": "유산소 운동 기구에 연결된 Life Fitness 및 Cybex 전용.",
      "onboardingSkipButton": "건너뛰기",
      "onboardingNextButton": "다음",
      "onboardingDoneButton": "완료",
      "onboardingSupportMessage": "이 위젯에서 어느 기구 콘솔을 지원하는지 알아 보세요.",
      "supportedTitle": "지원하는 콘솔",
      "supportedMessage": "이 위젯은 Life Fitness <strong>Discover SE3, SE3HD, ST 콘솔 및 Cybex 70T</strong> 콘솔을 통한 Life Fitness Elevation Series 유산소 운동만을 지원합니다.",
      "onboardingAvailabilityMessage": "어느 기구를 이용할 수 있는지 또는 언제 이용할 수 있게 되는지 확인하세요",
      "graphTitle": "인기있는 시간대",
      "graphMoreInfoMessage": "Life Fitness 또는 Cybex 연결 기구의 이용 가능성에 근거함",
      "graphToday": "오늘",
      "graphNoDataMessage": "데이터와 함께 그래프를 제시합니다. 나중에 다시 시도하시기 바랍니다.",
      "availabilityOnDemandMessage": "귀하의 체육관에서 Life Fitness™ On Demand 클래스를 사용합니다. 모든 피트니스 수준의 훈련자들이 10~40분 운동을 할 수 있도록 섬세하게 설계된 동기를 부여해 주는 강사 주도 유산소 운동 클래스입니다.",
      "treadmills": "러닝 머신",
      "crossTrainers": "크로스 트레이너",
      "recumbentBikes": "좌식 자전거",
      "uprightBikes": "입식 자전거",
      "powermills": "파워밀",
      "gscTrainers": "GSC 트레이너",
      "arcTrainers": "아크 트레이너",
      "unavailableEquipmentMessage": "아래 시간에는 운동 지속 시간이 표시됩니다.",
      "january": "1월",
      "feburary": "2월",
      "march": "3월",
      "april": "4월",
      "may": "5월",
      "june": "6월",
      "july": "7월",
      "august": "8월",
      "september": "9월",
      "october": "10월",
      "november": "11월",
      "december": "12월"
    }
  },
  nl: {
    translation: {
      "available": "BESCHIKBAAR",
      "unavailable": "NIET BESCHIKBAAR",
      "getStartButton": "Aan de slag",
      "getStartedAvailabilityTitle": "BESCHIKBAARHEID TOESTELLEN",
      "getStartedAvailabilityMessage": "Gefrustreerd omdat je favoriete cardiotoestel in gebruik is wanneer jij het wilt gebruiken?  Maak je geen zorgen, we kunnen je nu laten zien of je favoriete toestel beschikbaar is.",
      "getStartedOnDemandTitle": "OP ZOEK NAAR MOTIVERENDE TRAININGEN OP AANVRAAG",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand zijn kwalitatief hoogwaardige, motiverende trainingen op populaire muziek. De trainingen bieden een breed scala van programmeerwijzen voor de beginnende, de gemiddelde en de gevorderde sporter.",
      "getStartedCardioConsolesTitle": "LIFE FITNESS- en CYBEX-CARDIOCONSOLES",
      "getStartedCardioConsolesMessage": "Deze website ondersteunt alleen Life Fitness Elevation Series-cardio met de consoles Discover SE3, SE3HD, ST en Cybex 70T.",
      "getStartedBottomMessage": "Alleen voor Life Fitness en Cybex connected cardiotoestellen.",
      "onboardingSkipButton": "Overslaan",
      "onboardingNextButton": "Volgende",
      "onboardingDoneButton": "Gereed",
      "onboardingSupportMessage": "Bekijk welke toestelconsoles worden ondersteund in deze widget.",
      "supportedTitle": "ONDERSTEUNDE CONSOLES",
      "supportedMessage": "Deze widget ondersteunt alleen Life Fitness Elevation Series-cardio met de consoles Life Fitness <strong>Discover SE3, SE3HD, ST en de Cybex 70T</strong>-consoles.",
      "onboardingAvailabilityMessage": "Bekijk welke toestellen beschikbaar zijn of wanneer er een beschikbaar zou kunnen komen",
      "graphTitle": "POPULAIRE TIJDSTIPPEN",
      "graphMoreInfoMessage": "Op basis van de beschikbaarheid van Life Fitness- of Cybex-verbonden toestellen",
      "graphToday": "Vandaag",
      "graphNoDataMessage": "We zijn bezig de grafiek te vullen met gegevens. Bekijk deze later nog eens.",
      "availabilityOnDemandMessage": "Je sportschool heeft Life Fitness™ On Demand-trainingen geactiveerd. Dit zijn motiverende cardiotrainingen onder leiding van een instructeur op verschillende soorten toestellen. De trainingen zijn zorgvuldig samengesteld voor sporters van elk fitnessniveau en duren tussen 10 en 40 minuten.",
      "treadmills": "Loopbanden",
      "crossTrainers": "Cross-trainers",
      "recumbentBikes": "Recumbent Bikes",
      "uprightBikes": "Rechtopstaande fietsen",
      "powermills": "Powermills",
      "gscTrainers": "GSC Trainers",
      "arcTrainers": "Arc Trainers",
      "unavailableEquipmentMessage": "De tijd hieronder geeft de verstreken tijd van de training aan.",
      "january": "Januari",
      "feburary": "Februari",
      "march": "Maart",
      "april": "April",
      "may": "Mei",
      "june": "Juni",
      "july": "Juli",
      "august": "Augustus",
      "september": "September",
      "october": "Oktober",
      "november": "November",
      "december": "December"
    }
  },
  pl: {
    translation: {
      "available": "DOSTĘPNE",
      "unavailable": "NIEDOSTĘPNE",
      "getStartButton": "Rozpocznij",
      "getStartedAvailabilityTitle": "DOSTĘPNOŚĆ SPRZĘTU",
      "getStartedAvailabilityMessage": "Denerwuje Cię, gdy Twoje ulubione urządzenie cardio jest zajęte, gdy chcesz z niego skorzystać?  Teraz możemy wysyłać Ci powiadomienia, kiedy Twoje ulubione urządzenie treningowe się zwolni.",
      "getStartedOnDemandTitle": "SZUKAJ MOTYWUJĄCYCH LEKCJI NA ŻYCZENIE",
      "getStartedOnDemandMessage": "Wysokiej jakości lekcje motywacyjne Life Fitness™ On Demand z popularną muzyką. Lekcje zapewniają szeroki wybór programów dla początkujących, średnio zaawansowanych i zaawansowanych.",
      "getStartedCardioConsolesTitle": "KONSOLE CARDIO LIFE FITNESS I CYBEX",
      "getStartedCardioConsolesMessage": "W tej witrynie obsługiwane są wyłącznie konsole cardio Life Fitness Elevation Series z Discover SE3, SE3HD, ST oraz konsole Cybex 70T.",
      "getStartedBottomMessage": "Dotyczy tylko powiązanych produktów cardio Life Fitness i Cybex.",
      "onboardingSkipButton": "Pomiń",
      "onboardingNextButton": "Następny",
      "onboardingDoneButton": "Gotowe",
      "onboardingSupportMessage": "Sprawdź, które konsole sprzętowe są obsługiwane w tym widżecie.",
      "supportedTitle": "OBSŁUGIWANE KONSOLE",
      "supportedMessage": "Ten widżet obsługuje tylko konsole cardio Life Fitness Elevation Series z Life Fitness <strong>Discover SE3, SE3HD, ST, i konsole Cybex 70T</strong>.",
      "onboardingAvailabilityMessage": "Sprawdź, które urządzenie treningowe jest dostępne lub kiedy może się zwolnić",
      "graphTitle": "POPULARNE PORY",
      "graphMoreInfoMessage": "Na podstawie dostępności powiązanych urządzeń treningowych Life Fitness lub Cybex",
      "graphToday": "Dzisiaj",
      "graphNoDataMessage": "Aktualnie przesyłany dane do wykresu. Sprawdź później.",
      "availabilityOnDemandMessage": "W Twojej siłowni są teraz dostępne lekcje Life Fitness™ On Demand. Są to motywacyjne lekcje cardio z instruktorem trwające od 10 do 40 minut. Zostały starannie opracowane z wykorzystaniem różnych rodzajów urządzeń treningowych odpowiednio do potrzeb różnych osób.",
      "treadmills": "Bieżnie",
      "crossTrainers": "Uniwersalne trenażery",
      "recumbentBikes": "Rowery poziome",
      "uprightBikes": "Rowery pionowe",
      "powermills": "Urządzenia PowerMill",
      "gscTrainers": "Trenażery GSC",
      "arcTrainers": "Trenażery Arc Trainer",
      "unavailableEquipmentMessage": "Godzina poniżej wskazuje czas treningu, który upłynął",
      "january": "styczeń",
      "feburary": "luty",
      "march": "marzec",
      "april": "kwiecień",
      "may": "maj",
      "june": "czerwiec",
      "july": "lipiec",
      "august": "sierpień",
      "september": "wrzesień",
      "october": "październik",
      "november": "listopad",
      "december": "grudzień",
      "hourStatus": "Przedział godzinowy",
      "offline": "Offline",
      "console": "konsole",
      "features": "funkcje",
      "status": "status",
      "feedbackSend": "Wyślij nam informację zwrotną",
      "feedbackMessage": "Informacja zwrotna jest dla nas ważna. Dzięki temu możemy na bieżąco usprawniać stronę. Prosimy, zostaw swoją opinię poniżej:",
      "feedback": "FInformacja zwrotna",
      "email": "Adres E-mail (opcjonalnie)",
      "cancelButton": "ANULUJ",
      "sendButton": "WYŚLIJ",
      "nextButton": "NASTĘPNY",
      "doneButton": "GOTOWE",
      "noEquipment": "W tym momencie brak dostępnych urządzeń. Spróbuj ponownie później.",
      "learnSupported": "Sprawdź, które konsole maszyn cardio są obsługiwane przez ten widżet.",
      "learnAvialable": "Sprawdź, które urządzenie jest dostępne, lub kiedy będzie dostępn.",
      "statusTime": "Czas treningu, który upłynął.",
      "statusNotConnected": "Halo Fitness nie może się skomunikować  z tą maszyną."
    }
  },
  pt: {
    translation: {
      "available": "DISPONÍVEL",
      "unavailable": "NÃO DISPONÍVEL",
      "getStartButton": "Começar",
      "getStartedAvailabilityTitle": "DISPONIBILIDADE DO EQUIPAMENTO",
      "getStartedAvailabilityMessage": "Frustrado quando sua parte favorita do equipamento cardio está em uso e você quer usá-la?  Não se preocupe. Agora, nós podemos mostrar se o seu equipamento favorito está disponível.",
      "getStartedOnDemandTitle": "PROCURE AULAS MOTIVACIONAIS SOB DEMANDA",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand são aulas motivacionais de alta qualidade com música popular. As aulas oferecem uma grande variedade de estilos de planos de treinamento para usuários iniciantes, intermediários e avançados.",
      "getStartedCardioConsolesTitle": "PAINÉIS CARDIO LIFE FITNESS E CYBEX",
      "getStartedCardioConsolesMessage": "Este site é compatível somente com Life Fitness Elevation Series cardio com painéis Discover SE3, SE3HD, ST e Cybex 70T.",
      "getStartedBottomMessage": "Somente para equipamentos de cárdio conectado Life Fitness e Cybex.",
      "onboardingSkipButton": "Pular",
      "onboardingNextButton": "Avançar",
      "onboardingDoneButton": "Concluído",
      "onboardingSupportMessage": "Saiba quais painéis de equipamento são compatíveis com este widget.",
      "supportedTitle": "PAINÉIS COMPATÍVEIS",
      "supportedMessage": "Este widget é compatível somente com Life Fitness Elevation Series cardio com painéis Life Fitness <strong>Discover SE3, SE3HD, ST, e painéis Cybex 70T</strong>.",
      "onboardingAvailabilityMessage": "Verifique qual equipamento está disponível ou quando um equipamento ficará disponível",
      "graphTitle": "TEMPOS POPULARES",
      "graphMoreInfoMessage": "Com base na disponibilidade do equipamento conectado Life Fitness ou Cybex",
      "graphToday": "Hoje",
      "graphNoDataMessage": "Estamos preenchendo o gráfico com dados. Confira novamente mais tarde.",
      "availabilityOnDemandMessage": "Sua academia ativou aulas de Life Fitness™ On Demand. São aulas de cardio motivacionais guiadas por instrutor em diferentes tipos de equipamento, desenvolvidas especificamente para usuários de todos os níveis de condicionamento físico, variando entre 10 e 40 minutos.",
      "treadmills": "Esteiras",
      "crossTrainers": "Cross-trainers",
      "recumbentBikes": "Bicicletas horizontais",
      "uprightBikes": "Bicicletas verticais",
      "powermills": "Powermills",
      "gscTrainers": "GSC Trainers",
      "arcTrainers": "Arc Trainers",
      "unavailableEquipmentMessage": "O tempo abaixo indica o tempo decorrido do exercício.",
      "january": "Janeiro",
      "feburary": "Fevereiro",
      "march": "Março",
      "april": "Abril",
      "may": "Maio",
      "june": "Junho",
      "july": "Julho",
      "august": "Agosto",
      "september": "Setembro",
      "october": "Outubro",
      "november": "Novembro",
      "december": "Dezembro"
    }
  },
  ru: {
    translation: {
      "available": "СВОБОДНО",
      "unavailable": "ЗАНЯТО",
      "getStartButton": "Приступим",
      "getStartedAvailabilityTitle": "ДОСТУПНОСТЬ ОБОРУДОВАНИЯ",
      "getStartedAvailabilityMessage": "Расстроены, что любимый кардиотренажер занят, когда он вам нужен?  Не переживайте! Теперь мы можем вам сообщить, когда ваш любимый тренажер освободится.",
      "getStartedOnDemandTitle": "ИЩИТЕ МОТИВАЦИОННЫЕ ЗАНЯТИЯ ПО ЗАПРОСУ",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand — это высококачественные мотивационные занятия, проводимые под популярную музыку. Занятия предоставляют широкий выбор стилей программ для начинающих, средних и опытных пользователей.",
      "getStartedCardioConsolesTitle": "КАРДИОКОНСОЛИ <strong>LIFE FITNESS & CYBEX",
      "getStartedCardioConsolesMessage": "Этот веб-сайт поддерживает только кардиотренажеры Life Fitness Elevation Series с консолями Discover SE3, SE3HD, ST и Cybex 70T.",
      "getStartedBottomMessage": "Только для кардиотренажеров Life Fitness & Cybex, подключенных к Интернету.",
      "onboardingSkipButton": "Пропустить",
      "onboardingNextButton": "Далее",
      "onboardingDoneButton": "Готово",
      "onboardingSupportMessage": "Узнайте, какие консоли тренажеров поддерживаются данным виджетом.",
      "supportedTitle": "ПОДДЕРЖИВАЕМЫЕ КОНСОЛИ",
      "supportedMessage": "Этот виджет поддерживает только кардиотренажеры Life Fitness Elevation Series с консолями Life Fitness Discover SE3, SE3HD, ST и Cybex 70T.",
      "onboardingAvailabilityMessage": "Узнайте, какие тренажеры свободны или когда они могут освободиться",
      "graphTitle": "ГРАФИК ЗАГРУЗКИ",
      "graphMoreInfoMessage": "График загрузки автоматически создается на основе статистики использования кардиотренажеров Life Fitness или Cybex подключенных к Интернет.",
      "graphToday": "Сегодня",
      "graphNoDataMessage": "Данные обновляются. Пожалуйста, попробуйте просмотреть эти данные позже.",
      "availabilityOnDemandMessage": "Попробуйте Life Fitness™ On Demand на консолях нашего клуба! Это видеоклассы популярных американских тренеров, разной интенсивности и продолжительности - от 10 до 40 минут.",
      "treadmills": "БЕГОВЫЕ ДОРОЖКИ",
      "crossTrainers": "КРОСС-ТРЕНАЖЕРЫ",
      "recumbentBikes": "ГОРИЗОНТАЛЬНЫЕ ВЕЛОТРЕНАЖЕРЫ",
      "uprightBikes": "ВЕРТИКАЛЬНЫЕ ВЕЛОТРЕНАЖЕРЫ",
      "powermills": "PowerMill",
      "gscTrainers": "Тренажеры GSC",
      "arcTrainers": "Эллиптические тренажеры",
      "unavailableEquipmentMessage": "Указанное ниже значение времени обозначает истекшее время тренировки.",
      "january": "Январь",
      "feburary": "Февраль",
      "march": "Март",
      "april": "Апрель",
      "may": "Май",
      "june": "Июнь",
      "july": "Июль",
      "august": "Август",
      "september": "Сентябрь",
      "october": "Октябрь",
      "november": "Ноябрь",
      "december": "Декабрь",
      "hourStatus": "Over 1 Hour",
      "offline": "Offline",
      "console": "Консоли",
      "features": "На консолях",
      "status": "Статус",
      "notConnected": "Нет соединения",
      "feedbackSend": "Отправьте нам свой отзыв",
      "feedbackMessage": "Ваш отзыв по использованию данного виджета очень важен для нас. Пожалуйста, расскажите нам об использовании данное виджета ниже:",
      "feedback": "Отзыв",
      "email": "E-mail (не обязательно)",
      "cancelButton": "ОТМЕНА",
      "sendButton": "ОТПРАВИТЬ",
      "nextButton": "ДАЛЕЕ",
      "doneButton": "Готово",
      "noEquipment": "В данный момент оборудования в данной категории нет.",
      "learnSupported": "Узнайте, какие консоли тренажеров поддерживаются данным виджетом.",
      "learnAvailable": "Узнайте, какие тренажеры свободны или когда они могут освободиться",
      "statusTime": "The time indicates workout elasped time.",
      "statusNotConnected": "Halo Fitness is unable to communicate with this equipment."
    }
  },
  sv: {
    translation: {
      "available": "TILLGÄNGLIGT",
      "unavailable": "INTE TILLGÄNGLIGT",
      "getStartButton": "Kom i gång",
      "getStartedAvailabilityTitle": "TILLGÄNGLIGHET AV UTRUSTNING",
      "getStartedAvailabilityMessage": "Blir du tokig på att det konditionsredskap du gillar bäst är upptaget när du vill använda det?  Oroa dig inte: vi kan nu visa dig om din favoritutrustning är ledig.",
      "getStartedOnDemandTitle": "HÅLL UTKIK EFTER MOTIVERANDE TRÄNINGSPASS PÅ BEGÄRAN",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand är högkvalitativa, motiverande träningspass med populär musik. Passen omfattar en stor mängd programstilar för nybörjare, normala och avancerade.",
      "getStartedCardioConsolesTitle": "KONDITIONSTRÄNINGSDISPLAYERNA <strong>LIFE FITNESS OCH CYBEX",
      "getStartedCardioConsolesMessage": "Denna webbplats stöder bara Life Fitness Elevation Series-konditionsträning med displayerna Discover SE3, SE3HD, ST och Cybex 70T.",
      "getStartedBottomMessage": "Endast för uppkopplad Life Fitness- och Cybex-konditionsutrustning.",
      "onboardingSkipButton": "Hoppa över",
      "onboardingNextButton": "Nästa",
      "onboardingDoneButton": "Klar",
      "onboardingSupportMessage": "Se vilka träningsdisplayer som stöds i denna widget.",
      "supportedTitle": "DISPLAYER SOM STÖDS",
      "supportedMessage": "Denna widget stöder bara Life Fitness Elevation Series-konditionsträning med displayerna Life Fitness <strong>Discover SE3, SE3HD, ST samt Cybex 70T</strong>.",
      "onboardingAvailabilityMessage": "Kolla vilken utrustning som är ledig eller när någon maskin kan bli ledig",
      "graphTitle": "POPULÄRA TIDER",
      "graphMoreInfoMessage": "Beror på tillgängligheten av uppkopplad Life Fitness- eller Cybex-utrustning",
      "graphToday": "I dag",
      "graphNoDataMessage": "Vi fyller grafen med data. Kom tillbaka senare.",
      "availabilityOnDemandMessage": "Ditt gym har börjat använda Life Fitness™ On Demand-träningspass. Det är motiverande, instruktörsledda konditionsträningspass på olika typer av utrustning, som har designats med eftertanke för att passa tränande på alla nivåer. Passen vara mellan 10 och 40 minuter.",
      "treadmills": "Löpband",
      "crossTrainers": "Crosstrainers",
      "recumbentBikes": "Tillbakalutade cyklar",
      "uprightBikes": "Upprätta träningscyklar",
      "powermills": "Powermills",
      "gscTrainers": "GSC-trainers",
      "arcTrainers": "Arc-trainers",
      "unavailableEquipmentMessage": "Tiden nedan visar hur lång tid som har gått av träningspasset.",
      "january": "Januari",
      "feburary": "Februari",
      "march": "Mars",
      "april": "April",
      "may": "Maj",
      "june": "Juni",
      "july": "Juli",
      "august": "Augusti",
      "september": "September",
      "october": "Oktober",
      "november": "November",
      "december": "December"
    }
  },
  tr: {
    translation: {
      "available": "KULLANILABİLİR",
      "unavailable": "KULLANILABİLİR DEĞİL",
      "getStartButton": "Başlayın",
      "getStartedAvailabilityTitle": "EKİPMAN KULLANILABİLİRLİĞİ",
      "getStartedAvailabilityMessage": "En sevdiğiniz kardiyo ekipmanlarını kullanmak istediğinizde kullanımda olduğunu görüp hayal kırıklığına mı uğradınız?  Merak etmeyin, artık size en sevdiğiniz ekipmanın kullanılabilir olup olmadığını gösterebiliriz.",
      "getStartedOnDemandTitle": "MOTİVE EDİCİ İSTEĞE BAĞLI DERSLER ARAYIN",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand popüler müziklerle birlikte sunulan yüksek kaliteli, motive edici derslerdir. Bu dersler, hem yeni başlayanlara hem de orta ve ileri seviyedeki sporculara hitap eden çok çeşitli programlama stilleri sunar.",
      "getStartedCardioConsolesTitle": "LIFE FITNESS VE CYBEX KARDİYO KONSOLLARI",
      "getStartedCardioConsolesMessage": "Bu web sitesi yalnızca Discover SE3, SE3HD, ST ve Cybex 70T konsolların bulunduğu Life Fitness Elevation Series kardiyo ekipmanlarını destekler.",
      "getStartedBottomMessage": "Yalnızca Life Fitness ve Cybex bağlantılı kardiyo ekipmanları içindir.",
      "onboardingSkipButton": "Atla",
      "onboardingNextButton": "Sonraki",
      "onboardingDoneButton": "Bitti",
      "onboardingSupportMessage": "Bu pencere öğesinde hangi ekipman konsollarının desteklendiğini öğrenin.",
      "supportedTitle": "DESTEKLENEN KONSOLLAR",
      "supportedMessage": "Bu pencere öğesi yalnızca Life Fitness <strong>Discover SE3, SE3HD, ST, konsolları ve Cybex 70T</strong> konsollarının bulunduğu Life Fitness Elevation Series kardiyo ekipmanlarını destekler.",
      "onboardingAvailabilityMessage": "Hangi ekipmanın kullanılabilir olduğunu veya ne zaman kullanılabilir olacağını kontrol edin",
      "graphTitle": "POPÜLER SAATLER",
      "graphMoreInfoMessage": "Life Fitness veya Cybex bağlantılı ekipmanın kullanılabilirliğine göre",
      "graphToday": "Bugün",
      "graphNoDataMessage": "Grafiği verilerle dolduruyoruz. Lütfen daha sonra tekrar kontrol edin.",
      "availabilityOnDemandMessage": "Spor salonunuz Life Fitness™ On Demand derslerini etkinleştirdi. Bunlar, 10 - 40 dakika arasında değişen, tüm fitness seviyelerindeki sporculara ulaşmak için özenle tasarlanmış, farklı ekipman türlerinde eğitmen rehberliğinde motive edici kardiyo dersleridir.",
      "treadmills": "Koşu Bantları",
      "crossTrainers": "Cross Trainer'lar",
      "recumbentBikes": "Yatay Bisikletler",
      "uprightBikes": "Dikey Bisikletler",
      "powermills": "Powermill'ler",
      "gscTrainers": "GSC Trainer'lar",
      "arcTrainers": "Arc Trainer'lar",
      "unavailableEquipmentMessage": "Antrenmanda geçen süre aşağıda gösterilmektedir.",
      "january": "Ocak",
      "feburary": "Şubat",
      "march": "Mart",
      "april": "Nisan",
      "may": "Mayıs",
      "june": "Haziran",
      "july": "Temmuz",
      "august": "Ağustos",
      "september": "Eylül",
      "october": "Ekim",
      "november": "Kasım",
      "december": "Aralık"
    }
  },
  zh: {
    translation: {
      "available": "可用",
      "unavailable": "不可用",
      "getStartButton": "开始",
      "getStartedAvailabilityTitle": "设备可用性",
      "getStartedAvailabilityMessage": "当您要使用特别喜爱的那件有氧器械时有其他人正在使用它，这种情况是否让您感到沮丧？不必担心，我们现在可以向您展示您喜爱的器械是否可用。",
      "getStartedOnDemandTitle": "查找动感的按需课程",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand 是搭配流行音乐的高质量动感课程。这些课程为初级、中级、高级锻炼者提供多种多样的计划风格。",
      "getStartedCardioConsolesTitle": "LIFE FITNESS & CYBEX 有氧器械控制台",
      "getStartedCardioConsolesMessage": "此网站仅支持配备 Discover SE3、SE3HD、ST 和 Cybex 70T 控制台的 Life Fitness Elevation Series 有氧器械。",
      "getStartedBottomMessage": "仅适用于 Life Fitness 和 Cybex 连接的有氧器械。",
      "onboardingSkipButton": "跳过",
      "onboardingNextButton": "下一步",
      "onboardingDoneButton": "完成",
      "onboardingSupportMessage": "了解此小工具中支持哪些器械控制台。",
      "supportedTitle": "支持的控制台",
      "supportedMessage": "此小工具仅支持配备 Life Fitness <strong>Discover SE3、SE3HD、ST、 控制台和 Cybex 70T</strong> 控制台的 Life Fitness Elevation Series 有氧器械。",
      "onboardingAvailabilityMessage": "查看哪件器械可用或何时某件器械可能变为可用",
      "graphTitle": "热门的锻炼时间",
      "graphMoreInfoMessage": "基于 Life Fitness 或 Cybex 连接的器械的可用性",
      "graphToday": "今天",
      "graphNoDataMessage": "我们正在为图表填充数据。请稍后返回查看。",
      "availabilityOnDemandMessage": "您的健身房启用了 Life Fitness™ On Demand 课程。这些课程是在不同器械类型上进行的有教练指导的动感有氧器械课程，经过缜密设计以适合所有体能水平的锻炼者，时长从 10 至 40 分钟不等。",
      "treadmills": "跑步机",
      "crossTrainers": "全功能训练器",
      "recumbentBikes": "卧式健身车",
      "uprightBikes": "直立式健身车",
      "powermills": "楼梯机",
      "gscTrainers": "GSC 训练器",
      "arcTrainers": "弧步训练器",
      "unavailableEquipmentMessage": "下方时间指示锻炼耗时。",
      "january": "一月",
      "feburary": "二月",
      "march": "三月",
      "april": "四月",
      "may": "五月",
      "june": "六月",
      "july": "七月",
      "august": "八月",
      "september": "九月",
      "october": "十月",
      "november": "十一月",
      "december": "十二月",
      "hourStatus": "一小1小时以上",
      "offline": "离线",
      "console": "有氧器械控制台",
      "features": "功能",
      "status": "状态",
      "feedbackSend": "意见反馈",
      "feedbackMessage": "您的意见反馈对我们非常重要。 这能帮助我们不断改善网站。 请留下您的意见反馈：",
      "feedback": "反馈",
      "email": "电邮地址（可选）",
      "cancelButton": "取消",
      "sendButton": "傅送",
      "nextButton": "下一步",
      "doneButton": "完成",
      "noEquipment": "目前没有可用的设备。 请稍后再查看。",
      "learnSupported": "了解哪些設備的控制台支援此功能",
      "learnAvialable": "了解哪些設備支援此功能",
      "statusTime": "顯示已完成的訓練時間。",
      "statusNotConnected": "Halo Fitness无法与此设备连线"
    }
  },
  zhl: {
    translation: {
      "available": "可使用",
      "unavailable": "無法使用",
      "getStartButton": "開始",
      "getStartedAvailabilityTitle": "器材可用性",
      "getStartedAvailabilityMessage": "當您想要使用最愛的有氧器材時，是否因為該器材已被人使用而感到沮喪？不用擔心，現在我們可以讓您知道您最愛的器材是否可用。",
      "getStartedOnDemandTitle": "尋找可激發動力的自選課程",
      "getStartedOnDemandMessage": "Life Fitness™ On Demand 是可激發動力的高品質課程，課堂中會播放流行音樂。這類課程為初級、中級和高級健身者提供各式各樣的編排風格。",
      "getStartedCardioConsolesTitle": "LIFE FITNESS 與 CYBEX 心肺訓練主控台",
      "getStartedCardioConsolesMessage": "此網站僅支援具有 Discover SE3、SE3HD、SI、和 Cybex 70T 主控台的 Life Fitness Elevation Series 心肺訓練。",
      "getStartedBottomMessage": "僅適用於 Life Fitness 和 Cybex 連線有氧器材。",
      "onboardingSkipButton": "略過",
      "onboardingNextButton": "下一個",
      "onboardingDoneButton": "完成",
      "onboardingSupportMessage": "了解此 Widget 支援哪些器材主控台。",
      "supportedTitle": "支援的主控台",
      "supportedMessage": "此 Widget 僅支援具有 Life Fitness <strong>Discover SE3、SE3HD、ST、主控台和 Cybex 70T</strong> 主控台的 Life Fitness Elevation Series 心肺訓練。",
      "onboardingAvailabilityMessage": "查看哪一項器材可用或是何時可能可用",
      "graphTitle": "熱門時間",
      "graphMoreInfoMessage": "根據 Life Fitness 或 Cybex 連線器材的可用性",
      "graphToday": "今天",
      "graphNoDataMessage": "我們正在用資料填入圖形。請稍後回來查看。",
      "availabilityOnDemandMessage": "您的健身房已啟用 Life Fitness™ On Demand 課程。這些是可激發動力並由教練指導的有氧課程，涉及不同的器材類型，課程都經過精心設計，適合所有體適能等級的健身者參與，課程時間從 10 到 40 分鐘不等。",
      "treadmills": "跑步機",
      "crossTrainers": "交叉訓練機",
      "recumbentBikes": "臥式健身車",
      "uprightBikes": "直立式健身車",
      "powermills": "PowerMill",
      "gscTrainers": "GSC 訓練機",
      "arcTrainers": "Arc Trainer",
      "unavailableEquipmentMessage": "底下時間表示健身時間。",
      "january": "一月",
      "feburary": "二月",
      "march": "三月",
      "april": "四月",
      "may": "五月",
      "june": "六月",
      "july": "七月",
      "august": "八月",
      "september": "九月",
      "october": "十月",
      "november": "十一月",
      "december": "十二月",
      "hourStatus": "一小時以上",
      "offline": "離線",
      "console": "心肺訓練主控台",
      "features": "功能",
      "status": "狀態",
      "feedbackSend": "給予反饋",
      "feedbackMessage": "您的反饋對我們非常重要，能讓我們不斷改善網站，請在下面提供你的寶貴意見：",
      "feedback": "意見",
      "email": "電郵地址（選填)",
      "cancelButton": "取消",
      "sendButton": "傅送",
      "nextButton": "下一步",
      "doneButton": "完成",
      "noEquipment": "目前沒有可用的設備。請稍後再看。",
      "learnSupported": "了解哪些設備的控制台支援此功能",
      "learnAvialable": "了解哪些設備支援此功能",
      "statusTime": "顯示已完成的訓練時間。",
      "statusNotConnected": "Halo Fitness無法與此設備連接"
    }
  }
}